<div class="header">
  <h3>{{ 'developer.webhookDetails.webhookEventDetails' | translate }}</h3>
  <a
    (click)="backToWebhookEvents()"
    tabindex="0"
    (keydown.enter)="backToWebhookEvents()"
    class="back-link"
    >&lt;&lt;&nbsp;{{ 'common.backTo' | translate }}
    <span id="prev-url-name">{{ 'developer.webhookDetails.webhookLogs' | translate }}</span></a
  >
</div>

@if (isLoader()) {
  <app-loader></app-loader>
}

<div class="details-container">
  <div class="card-row">
    <div class="details-card event-details">
      <div class="details-header">
        <h5>{{ 'developer.webhookDetails.webhookEventDetails' | translate }}</h5>
        <div
          id="user-status"
          class="status-button"
          [ngClass]="[
            webhookStatus === 'Accepted' ? 'green' : '',
            webhookStatus === 'Sent' ? 'green' : '',
            webhookStatus === 'Failed' ? 'red' : '',
            webhookStatus === 'Suspended' ? 'purple' : '',
            webhookStatus === 'Pending' ? 'yellow' : '',
            webhookStatus === 'In progress' ? 'blue' : '',
          ]"
        >
          <div class="status-circle"></div>
          <span class="status-text">
            {{ webhookStatus }}
          </span>
        </div>
      </div>
      <div class="detail-row">
        <span class="row-key">{{ 'developer.webhookDetails.dateCreated' | translate }}</span>
        @if (webhookEventLogDetails?.createdOn) {
          <span class="row-value" title="{{ webhookEventLogDetails?.createdOn | date }}">{{
            webhookEventLogDetails?.createdOn | date
          }}</span>
        }
        @if (!webhookEventLogDetails?.createdOn) {
          <span class="row-value">--</span>
        }
      </div>
      <div class="detail-row">
        <span class="row-key">{{ 'developer.webhookDetails.dateDelivered' | translate }}</span>
        @if (webhookEventLogDetails?.createdOn) {
          <span class="row-value" title="{{ webhookEventLogDetails?.createdOn | date }}">{{
            webhookEventLogDetails?.createdOn | date
          }}</span>
        }
        @if (!webhookEventLogDetails?.createdOn) {
          <span class="row-value">--</span>
        }
      </div>
      <div class="detail-row">
        <span class="row-key">{{ 'developer.webhookDetails.eventType' | translate }}</span>
        <span class="row-value break-line" title="{{ eventTypeToShow ? eventTypeToShow : '--' }}">{{
          eventTypeToShow ? eventTypeToShow : '--'
        }}</span>
      </div>
      @if (webhookEventLogDetails?.moduleName === 'Transaction') {
        <div class="detail-row">
          <span class="row-key">{{ 'developer.webhookDetails.transactionID' | translate }}</span>
          <span class="row-value" title="{{ webhookEventLogDetails?.entityId }}">
            <span class="cap-ellipsis">
              {{ webhookEventLogDetails?.entityId }}
            </span>
            <span
              class="material-symbols-outlined copy-icon"
              (click)="allyCommonService.copyValueToClipboard(webhookEventLogDetails?.entityId)"
              tabindex="0"
              (keydown.enter)="
                allyCommonService.copyValueToClipboard(webhookEventLogDetails?.entityId)
              "
              >&#xe14d;</span
            >
          </span>
        </div>
      }
      <div class="detail-row">
        <span class="row-key">{{ 'developer.webhookDetails.webhookID' | translate }}</span>
        <span
          class="row-value"
          title="{{
            webhookEventLogDetails?.subscriptionId ? webhookEventLogDetails?.subscriptionId : '--'
          }}"
        >
          <span class="cap-ellipsis">
            {{
              webhookEventLogDetails?.subscriptionId ? webhookEventLogDetails?.subscriptionId : '--'
            }}
          </span>
          @if (webhookEventLogDetails?.webhookUrl) {
            <span
              class="material-symbols-outlined copy-icon"
              (click)="
                allyCommonService.copyValueToClipboard(webhookEventLogDetails?.subscriptionId)
              "
              tabindex="0"
              (keydown.enter)="
                allyCommonService.copyValueToClipboard(webhookEventLogDetails?.subscriptionId)
              "
              >&#xe14d;</span
            >
          }
        </span>
      </div>
      <div class="detail-row">
        <span class="row-key">{{ 'developer.webhookDetails.url' | translate }}</span>
        <span
          class="row-value"
          title="{{
            webhookEventLogDetails?.webhookUrl ? webhookEventLogDetails?.webhookUrl : '--'
          }}"
        >
          <span class="break-line">
            {{ webhookEventLogDetails?.webhookUrl ? webhookEventLogDetails?.webhookUrl : '--' }}
          </span>
          @if (webhookEventLogDetails?.webhookUrl) {
            <span
              class="material-symbols-outlined copy-icon"
              (click)="allyCommonService.copyValueToClipboard(webhookEventLogDetails?.webhookUrl)"
              tabindex="0"
              (keydown.enter)="
                allyCommonService.copyValueToClipboard(webhookEventLogDetails?.webhookUrl)
              "
              >&#xe14d;</span
            >
          }
        </span>
      </div>
    </div>

    <div class="details-card actions">
      <div class="details-header">
        <h5>{{ 'developer.webhookDetails.actions' | translate }}</h5>
      </div>
      <a
        role="button"
        (click)="actionTriggered()"
        tabindex="0"
        (keydown.enter)="actionTriggered()"
        class="button button-green"
        >{{ 'developer.webhookDetails.retriggerWebhookEvent' | translate }}</a
      >
    </div>
  </div>

  <div class="card-row">
    <div class="details-card code">
      <div class="details-header">
        <h5>{{ 'developer.webhookDetails.webhookResponse' | translate }}</h5>
      </div>
      <pre [innerHTML]="responseType === 'html' ? modifiedResponseMessage : responseMessage"></pre>
    </div>
    <div class="details-card code">
      <div class="details-header">
        <h5>{{ 'developer.webhookDetails.webhookBody' | translate }}</h5>
      </div>
      <pre>
          {{
          webhookBodyParsedResponse === 'No Data Available'
            ? webhookBodyParsedResponse
            : (webhookBodyParsedResponse | json)
        }}
        </pre>
    </div>
  </div>
</div>
